import { PropTypes } from 'prop-types';
import { downloadFileFromS3 } from '@/component/common/FileUploaded';
import Utils from '@/common/utils/utils';
import TooltipThumb from '@/component/common/TooltipThumb';
import { displayTagOfThumbAttach } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';

function EmailOtherAttachment({
    file,
    detailTicket,
    setIsShowPopupLogout,
    setOpenFileOption,
    setOpenOption
}) {
    if (!file) return null;

    let tempFile = { type: 1, ...file };
    const displayTextInFile = displayTagOfThumbAttach(detailTicket || {}, file.fileName);
    const attachFile = detailTicket?.attachFiles?.find(attach => {
        const attachFileUrl = attach?.fileInfo?.fileUrl || attach?.s3Path;
        return attachFileUrl === file?.fileUrl;
    });
    const handleOpenFile = e => {
        e?.preventDefault?.();
        downloadFileFromS3(tempFile, detailTicket, false, false, '', setIsShowPopupLogout);
    };

    return (
        <li className="justify-content-center" style={{ marginBottom: 0 }}>
            <div className="display-thumb">
                <div
                    className="class-relative cursor-default listmap-item"
                    style={{ display: 'flex', gap: 5 }}
                >
                    <TooltipThumb
                        value={`${file.fileName}(${Utils.formatBytes(file.fileSize)})`}
                        className="titleDisplay"
                    >
                        <img
                            style={{
                                height: 50,
                                width: 70,
                                objectFit: 'cover',
                                cursor: 'pointer'
                            }}
                            src="/assets/image/others_file.png"
                            alt=""
                            onClick={handleOpenFile}
                        />
                    </TooltipThumb>
                    {attachFile && (
                        <div
                            style={{
                                height: 50,
                                backgroundColor: '#ecedef',
                                width: 20,
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                            onClick={e => {
                                setOpenFileOption?.(attachFile);
                                setOpenOption?.(e.currentTarget);
                            }}
                        >
                            <img src="/assets/image/icon-more-panel.svg" alt="" />
                        </div>
                    )}
                    <span
                        style={{
                            backgroundColor: displayTextInFile.colorCode,
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            color: 'white',
                            borderBottomRightRadius: 5,
                            fontSize: 11,
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            maxWidth: 60,
                            minHeight: 14,
                            minWidth: 33,
                            zIndex: 1
                        }}
                    >
                        {displayTextInFile.name}
                    </span>
                </div>
            </div>
        </li>
    );
}

EmailOtherAttachment.propTypes = {
    file: PropTypes.any,
    detailTicket: PropTypes.any,
    setIsShowPopupLogout: PropTypes.func,
    setOpenFileOption: PropTypes.func,
    setOpenOption: PropTypes.func
};

export default EmailOtherAttachment;
